import React, { ForwardedRef } from 'react';
import { Box, BoxProps } from '@mui/material';

interface Props extends BoxProps {
  borderColor?: string;
  bgColor?: string;
  ref?: ForwardedRef<unknown>;
}

const TableDotIcon: React.FC<Props> = React.forwardRef((props: Props, ref) => {
  const {
    borderColor = 'transparent',
    bgColor = 'transparent',
    ...rest
  } = props;
  return (
    <Box
      ref={ref}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      bgcolor={borderColor}
      borderRadius="50%"
      height="14px"
      width="14px"
      sx={{
        '&::before': {
          content: `''`,
          position: 'absolute',
          backgroundColor: bgColor,
          borderRadius: 'inherit',
          height: '8px',
          width: '8px',
        },
      }}
      {...rest}
    />
  );
});

export default React.memo(TableDotIcon);
